import classNames from 'classnames';
import PropTypes from 'prop-types'

import '/assets/styles/partials/info-box.scss';

const InfoBox = ({ children, title, plain, className }) => {
	return (
		<div className={classNames('infobox', className, { plain })}>
			{title &&
				<strong className="infobox-title">{title}</strong>
			}
			{children}
		</div>
	)
}

InfoBox.propTypes = {
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	children: PropTypes.node,
	className: PropTypes.string,
}

export default InfoBox;